import clsx from 'clsx';
import { IconWithSpinner } from '@/core/IconWithSpinner.atom';

interface LoadingFallbackProps {
  size?: 'lg' | 'sm';
}

/**
 * Loading spinner to use as the fallback with React.Suspense. Fills the entire element.
 */
export const LoadingFallback = ({ size = 'lg' }: LoadingFallbackProps) => {
  return (
    <div
      data-testid="loadingFallback"
      className="flexColumnContainer flexFill height-maximum tw:items-center tw:justify-center">
      <IconWithSpinner spinning={true} extraClassNames={clsx({ 'fa-5x': size === 'lg' })} />
    </div>
  );
};
